<template>
  <v-card
    flat
    tile
    hover
    class='pa-1'
    :to="link"
  >
    <v-responsive
      height="200px"
    >
      <span class='groupType py-1 px-2 ml-3 elevation-1'>{{ group | accessLevel }}</span>
      <v-container fill-height fluid class='titleBackground pa-3' v-bind:class="tileTypeClass">
        <v-layout fill-height row wrap>
          <v-flex xs12 flexbox class='photo' :id="groupId" :style="photoObject">
            <div class="photoInner"></div>
          </v-flex>
          <v-flex class='groupName'>
            <h3 class=''>{{group.name}}</h3>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
    <v-card-actions class='pa-1'>
      <slot name="card-actions"></slot>
      <v-spacer></v-spacer>
      <v-btn flat icon text><v-icon>arrow_forward</v-icon></v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.photo {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 90px;
  width: 100%;
  background-color: $amaze-yellow;
}

.titleBackground {
  h3 {
    color: #000;
    font-size: 24px;
    line-height: 120%;
    margin-top: 80px;
    // text-shadow: 0px 0px 5px #b89436;
  }
}
.v-card__actions{
  font-style: italic;
  color:#585858 !important;
}
.groupName h3{
  font-weight: 700px;
  font-size: 20px;
  line-height: 24px;
}
.groupType {
  position: absolute;
  background-color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  font-family: $amaze-header-font-stack;
  z-index: 2;
  color: $font-color;
  font-size: 14px;
}
</style>

<script>
export default {
  props: {
    group: Object,
    link: String,
    photoUrl: String,
    type: String
  },
  computed: {
    tileType() {
      return this.type ? this.type : 'Group';
    },
    groupId() {
      return 'groupId' + this.tileType + this.group.id;
    },
    tileTypeClass() {
      return 'tileType' + this.tileType;
    },
    photoObject() {
      if (this.photoUrl) {
        return {
          "background-image": "url(" + this.photoUrl + ")",
          "background-position": "center center",
          "background-size": "cover",
          opacity: 1
        };
      } else {
        return {
          opacity: 1
        };
      }
    }
  },
  filters: {
    accessLevel(group) {
      if (group.public) {
        return "Public";
      } else {
        return "Private";
      }
    }
  }
};
</script>
